import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { BenefitsService } from '../commonServices/benefits.service';

export const benefitsResolver: ResolveFn<any> = (route, state) => {
  return inject(BenefitsService).get();
};
